import { FaPalette } from "react-icons/fa";
import ContextContainer from "./components/ContextContainer";
import { ContextMenuItem, ContextMenuSeparator } from "./components/ui/context-menu";
import useMethodStore, { useMethodActions } from "./store/MethodStore";
import { useEffect } from "react";
import useSettingsStore from "./store/SettingsStore";
import { Toaster } from 'react-hot-toast'
import SearchBar from "./components/desktop/SearchBar";
import { MdRefresh, MdSettings, MdWallpaper } from "react-icons/md";
import getCookie from "./utils/getCookie";
import DragSelectionWrapper from "./components/desktop/DragSelectorWrapper";
import { syncRootTheme } from "./utils/themeMethods";
import DesktopApps from "./components/desktop/DesktopApps";
import Dock from "./components/desktop/Dock";
import AskMe from "./components/apps/AskMe";
import WidgetPanel from "./components/desktop/WidgetPanel";
import BSOD from "./components/desktop/BSOD";

export default function App() {

  const { setFocusedWindow, setSettingsState } = useMethodActions()
  const askMeState = useMethodStore(state => state.askMeState)
  const showBSOD = useMethodStore(state => state.showBSOD)
  const setWindowControlButtons = useSettingsStore(state => state.setWindowControlButtons)
  const setActiveTab = useSettingsStore(state => state.setActiveTab)
  const setTheme = useSettingsStore(state => state.setTheme)
  const theme = useSettingsStore(state => state.theme)
  const widgetPanel = useSettingsStore(state => state.widgetPanel)
  const backgroundImage = useSettingsStore(state => state.backgroundImage)

  useEffect(() => {
    const userVisitedFirstTime = getCookie("userVisitedFirstTime");
    if (userVisitedFirstTime) {
      syncRootTheme(theme)
    } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      syncRootTheme("dark")
      setTheme("dark")
    }
    setWindowControlButtons(/Windows|Linux/.test(window.navigator.userAgent));
  }, [setTheme, setWindowControlButtons, theme]);

  return (
    <>
      <ContextContainer trigger={
        <DragSelectionWrapper>
          <div
            id="app"
            style={{
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundImage: `url(${backgroundImage})`,
            }}
            className="px-2 pt-2 sm:px-4 sm:pt-4 pb-40 lg:pb-4 select-none grid grid-rows-7 lg:grid-rows-8 grid-cols-4 sm:grid-cols-6 xl:grid-cols-12 2xl:grid-cols-18 lg:grid-flow-col gap-1 bg-zinc-100 text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100 w-screen h-screen overflow-hidden"
          >
            <DesktopApps />
            <Dock />
            <WidgetPanel />
          </div>
        </DragSelectionWrapper>
      }>
        <ContextMenuItem onClick={() => { setActiveTab("general"); setSettingsState("floating"); setFocusedWindow("Settings") }}>
          <MdSettings className="text-lg" />
          <span className="ml-3">Settings</span>
        </ContextMenuItem>
        <ContextMenuSeparator />
        <ContextMenuItem onClick={() => { setActiveTab("appearance"); setSettingsState("floating"); setFocusedWindow("Settings") }}>
          <FaPalette className="text-lg" />
          <span className="ml-3">Appearance</span>
        </ContextMenuItem>
        <ContextMenuItem onClick={() => { setActiveTab("wallpapers"); setSettingsState("floating"); setFocusedWindow("Settings") }}>
          <MdWallpaper className="text-lg" />
          <span className="ml-3">Change wallpaper</span>
        </ContextMenuItem>
        <ContextMenuSeparator />
        <ContextMenuItem onClick={() => { window.location.reload() }}>
          <MdRefresh className="text-lg" />
          <span className="ml-3">Refresh</span>
        </ContextMenuItem>
      </ContextContainer>
      <SearchBar />
      <AskMe />
      {showBSOD && <BSOD />}
      <Toaster
        position={(window.innerWidth < 1024 || askMeState || widgetPanel) ? "top-center" : "top-right"}
        toastOptions={{
          style: {
            background: "#333e",
            color: "#fff",
            borderRadius: "50px",
            paddingLeft: "12px",
            paddingRight: "12px",
            fontSize: "16px",
          },
        }}
      />
    </>
  )
}